import * as Theme from "../../../../app/Theme";
import * as pias from "../../NonComponents/PIAppState";
import * as pic from "../../NonComponents/PIConst";
import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";
import PIDefCostsPerVisitRefTable from "../../Tables/Reference/PIDefCostsPerVisitRefTable";

const PIDefCostsPerVisitRefLiteForm = (props) => {
  const { modVarObjList, onDialogChange, onCalculatingChange } = props;

  return (
    <div style={{ paddingLeft: Theme.leftIndent }}>
      <p style={{ ...Theme.labelStyle }}>{RS(SC.GB_stDefCostsPerVisit)}</p>
      <PIDefCostsPerVisitRefTable
        {...{
          [pias.modVarObjList]: modVarObjList,
          [pias.onDialogChange]: onDialogChange,
          [pias.onCalculatingChange]: onCalculatingChange,
        }}
      />
      <div style={{ display: "flex", flexDirection: "column", marginTop: 20, ...Theme.textFontStyle, gap: 10 }}>
        <span>{RS(SC.GB_stDefaultCostReferencesNote)}</span>
        <div>
          <span style={{ textDecoration: "underline" }}>{RS(SC.GB_stReferences)}</span>
          <ul style={{ marginTop: 0, paddingLeft: 20 }}>
            {pic.defaultCostReferences.map((ref, i) => (
              <li key={i}>{ref}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PIDefCostsPerVisitRefLiteForm;
